// @flow

import * as React from 'react';

import { DiscountPrice } from 'src/shared/DiscountPrice';
import { RenewPrice } from 'src/shared/RenewPrice';

import { useExtendedSuggestion } from '../modules';

import { CatalogPrice } from './CatalogPrice';

type Props = {
  fqdn: string,
};

export function ProvidedDomainPrice({
  fqdn,
}: Props): React.MixedElement | null {
  const {
    suggestion,
    currency,
    price,
    minDuration,
    normalPrice,
    valid,
    hasDiscount,
    priceDiff,
    needsPhaseSelection,
  } = useExtendedSuggestion({ fqdn });

  if (!suggestion || !valid) return null;

  if (hasDiscount) {
    return (
      <DiscountPrice
        minDuration={minDuration}
        price={price}
        currency={currency}
        normalPrice={normalPrice}
      >
        <RenewPrice fqdn={fqdn} />
      </DiscountPrice>
    );
  }

  const showFromPrice = !suggestion.addedToCart && needsPhaseSelection;

  return (
    <CatalogPrice
      currency={currency}
      price={price}
      minDuration={minDuration}
      priceDiff={priceDiff}
      showFromPrice={showFromPrice}
    >
      <RenewPrice fqdn={fqdn} />
    </CatalogPrice>
  );
}
